"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sha512 = exports.sha256 = void 0;
const sha256_1 = require("@noble/hashes/sha256");
const sha512_1 = require("@noble/hashes/sha512");
const helpers_1 = require("./helpers");
const sha256 = (bytes) => {
    const digest = sha256_1.sha256.create()
        .update(bytes)
        .digest();
    return (0, helpers_1.bytesToHex)(digest);
};
exports.sha256 = sha256;
const sha512 = (bytes) => {
    const digest = sha512_1.sha512.create()
        .update(bytes)
        .digest();
    return (0, helpers_1.bytesToHex)(digest);
};
exports.sha512 = sha512;
//# sourceMappingURL=hash.js.map